module.exports = __webpack_public_path__ + "static/example-cover-4502d134368cb7d549832451118de55a.png";